import React, {useState} from 'react'
import {faCaretRight, faCaretLeft, faVolumeUp, faVolumeMute} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import './trailer.css'
import ReactPlayer from 'react-player/youtube'

function Trailer() {
    const [mute, setMute] = useState(true); // 초기 mute기능
    const [muteIcon, setMuteIcon] = useState(faVolumeMute); // mute 아이콘
    const [videoNum, setVideoNum] = useState(0); // 비디오 초깃값 0번

    /* useState 변수와 관련된 prev, next 버튼 클릭 이벤트 리스너 */
    function btnClick(e) {
        if (e === -1) { // 파라미터 -1이면 = 이전 버튼 클릭시 -> 맨 마지막 비디오로 감
            if (videoNum === 0) { // 첫번째 유튜브 비디오
                setVideoNum(2); // 맨 마지막 비디오 재생
            } else { // 0이 아니면 
                setVideoNum(videoNum + e)
            }
        } else if (e === 1) { // 다음 버튼 클릭시
            if (videoNum === 2) {
                setVideoNum(0);
            } else {
                setVideoNum(videoNum + e)
            }
        }
    }
    /* 음소거 함수 = 이벤트 리스너 */
    function muteClick() {
        if (!mute) {
            setMuteIcon(faVolumeMute); // 뮤트 아이콘
            setMute(true);
        } else {
            setMuteIcon(faVolumeUp);
            setMute(false);
        }
    }

    return (
        <section>
            <div className='btn_box'>
                {/* 이전버튼 */}
                <button className='prev' onClick={()=> btnClick(-1)}>
                    <FontAwesomeIcon icon={faCaretLeft} />
                    {/* span은 주석개념으로 써줘도 되고 안써줘도 됨 */}
                    <span>Prev</span>
                </button>
                {/* 가운데 Channel 00(초깃값) 뮤트아이콘 */}
                <h2>Channel
                    <span className='channel_number'>{video[videoNum].id}</span>
                </h2>
                {/* 음소거 */}
                <button className='mute' onClick={()=> muteClick()}>
                    <span className='btn_mute'><FontAwesomeIcon icon={muteIcon}/>mute/Unmute</span>
                </button>
                {/* 다음버튼 */}
                <button className='next' onClick={()=> btnClick(1)}>
                    <FontAwesomeIcon icon={faCaretRight}  />
                    <span>Next</span>
                </button>
            </div>
{/* ReactPlayer = 영상 요소로 플레이를 구현할 때 사용하는 라이브러리 | 유튜브 url을 갖고 커스텀한 비디오 플레이어를 구현 */}
            <div id='player'>
                <ReactPlayer 
                    url = {video[videoNum].url}
                    playing={true}
                    volume={.7}
                    muted={mute}
                    autoPlay={true}
                    loop={true}/>
            </div>
        </section>
    )
}

export default Trailer
/* 유튜브 영상 배열 객체 */
const video = [
    {
        id: '00',
        url: 'https://www.youtube.com/watch?v=qELSSAspRDI'
    }, {
        id: '01',
        url: 'https://www.youtube.com/watch?v=sj9J2ecsSpo'
    }, {
        id: '02',
        url: 'https://www.youtube.com/watch?v=UBhlqe2OTt4'
    }
]


